package ru.villawonka.app.presentation.screens.postCard.compose.layout

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.components.AppButton
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.postCard.compose.PostCardCallbacks
import ru.villawonka.app.presentation.screens.postCard.compose.view.PostDetailsCardView
import ru.villawonka.app.presentation.screens.postCard.compose.view.PostSummaryCardView
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardUIState
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_telegram_24

@Composable
fun PostCardDataStateLayout(
    state: PostCardUIState.Data,
    callbacks: PostCardCallbacks
) {
    Box(Modifier.fillMaxSize()) {
        Column(Modifier.verticalScroll(rememberScrollState())) {
            PostSummaryCardView(
                post = state.post,
                onImageEnlargeClick = callbacks.onImageClick,
                onShareClick = callbacks.onShareClick,
                onLikeClick = callbacks.onLikeClick,
                onConversationDetailsClick = callbacks.onConversationDetailsClick,
                onGoToSourceClick = callbacks.onGoToSourceClick
            )
            AppSpacer(16.dp)
            PostDetailsCardView(state.post)
            AppSpacer(136.dp)
        }
        if (state.sendMessageButtonVisible) {
            Box(
                modifier = Modifier
                    .background(
                        color = MaterialTheme.colors.surfaceMiddle,
                        shape = RoundedCornerShape(
                            topStart = 16.dp,
                            topEnd = 16.dp
                        )
                    )
                    .fillMaxWidth()
                    .padding(
                        start = 16.dp,
                        end = 16.dp,
                        top = 16.dp,
                        bottom = getTelegram()?.isAppleDevice()?.let { isAppleDevice ->
                            if (isAppleDevice) 32.dp
                            else 16.dp
                        } ?: 16.dp
                    )
                    .align(Alignment.BottomCenter)
            ) {
                AppButton(
                    text = AppResources.strings.postCardSendMessage,
                    icon = Res.drawable.ic_telegram_24,
                    type = AppButtonType.PRIMARY,
                    size = AppButtonSize.LARGE,
                    modifier = Modifier.fillMaxWidth(),
                    onClick = callbacks.onChatClick
                )
            }
        }
    }
}